import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "header"
}
const _hoisted_2 = {
  key: 0,
  class: "actions"
}
const _hoisted_3 = { class: "body" }
const _hoisted_4 = {
  key: 0,
  class: "empty"
}
const _hoisted_5 = {
  key: 1,
  class: "empty"
}
const _hoisted_6 = {
  key: 2,
  class: "empty"
}

import TileBase from "@/components/TileBase.vue";
import TileTitle from "@/components/TileTitle.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TileDashboard',
  props: {
    title: {},
    loading: {},
    error: {},
    emptySpace: {},
    empty: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TileBase, null, {
    default: _withCtx(() => [
      (_ctx.$props.title || _ctx.$slots.actions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _renderSlot(_ctx.$slots, "header", {}, () => [
              (_ctx.$props.title)
                ? (_openBlock(), _createBlock(TileTitle, {
                    key: 0,
                    title: _ctx.$props.title,
                    level: 2
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.$slots.actions)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "actions")
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (__props.loading)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.loading), 1))
          : (__props.error)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.error), 1))
            : (__props.emptySpace || __props.empty)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _renderSlot(_ctx.$slots, "empty", {}, () => [
                    _createTextVNode(_toDisplayString(__props.emptySpace), 1)
                  ])
                ]))
              : _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 3)
      ])
    ]),
    _: 3
  }))
}
}

})